import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { LicenseModule } from './license/license.module';
import { LoginModule } from './login/login.module';
import { FormsModule } from '@angular/forms';
import { AuthcllbackModule } from './auth-callback/auth-callback.module';
@NgModule({
    imports: [
        SharedModule,
        LicenseModule,
        LoginModule,
        AuthcllbackModule,
        FormsModule
    ],
    exports: [
        LicenseModule,
        LoginModule
    ]
})
export class AuthenticationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authentication/authentication.module.ts